<template>
    <Card>
        <FetchTable :handle="tableHandle" :url="table.url" :columns="table.columns" v-model:orders="table.orders">
            <template #td-name="{row}">
                <router-link :to="{ name: 'EditWarehousePage', params: { warehouseUuid: row.uuid } }">{{ row.name }}</router-link>
            </template>
            <template #td-created_at="{row}">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
        </FetchTable>
        <FixedBottomNavbar>
            <ul class="navbar-nav ml-md-auto">
                <li class="nav-item py-1">
                    <AlphaButton color="teal" size="" @click="$refs.modal.show()">
                        <span>{{ $t('buttons.create_new') }}</span>
                    </AlphaButton>
                </li>
            </ul>
        </FixedBottomNavbar>
    </Card>
    <CreateWarehouseModal ref="modal" @created="tableHandle.fetchRows()"/>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import AlphaButton from '../../../../components/new/button/AlphaButton.vue';
import FixedBottomNavbar from '../../../../components/new/navbars/FixedBottomNavbar.vue';
import CreateWarehouseModal from './modals/CreateWarehouseModal.vue';
import DateFormatter from '../../../../services/DateFormatter';
export default {
    name: "IndexWarehousePage",
    components: {
        Card, FetchTable, AlphaButton, FixedBottomNavbar, CreateWarehouseModal
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            table: {
                url: '/management/warehouses',
                orders: [],
                columns: [
                    {key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: true},
                    {key: 'name', name: this.$t('table.titles.name'), width: 'auto', type: 'string', order: true},
                    {key: 'products_count', name: this.$t('table.titles.products_count'), width: '200px', type: 'string', order: true},
                    {key: 'created_at', name: this.$t('table.titles.created_at'), width: '200px', type: 'string', order: true},
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows()
    }
}
</script>
